/**
 * WEBAPP-14: set_type canonici per schede palestra (allineamento API / UI).
 * REST-PAUSE escluso — non è un set_type selezionabile.
 */

export const GYM_WORKOUT_SET_TYPE_OPTIONS = [
    { value: 'normal', label: 'Normale' },
    { value: 'superset', label: 'Superset' },
    { value: 'dropset', label: 'Dropset' },
    { value: 'circuit', label: 'Circuit' },
    { value: 'giant_set', label: 'Giant Set' },
    { value: 'piramidale', label: 'Piramidale' },
];

const BADGE_CLASS_BY_TYPE = {
    superset: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300',
    dropset: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
    circuit: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
    giant_set: 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300',
    piramidale: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300',
};

export function getWorkoutSetTypeLabel(setType) {
    const opt = GYM_WORKOUT_SET_TYPE_OPTIONS.find((o) => o.value === setType);
    return opt?.label ?? setType;
}

export function getWorkoutSetTypeBadgeClass(setType) {
    return BADGE_CLASS_BY_TYPE[setType] ?? 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300';
}
